import script from "./DropMenuPost.vue?vue&type=script&setup=true&lang=js"
export * from "./DropMenuPost.vue?vue&type=script&setup=true&lang=js"

import "./DropMenuPost.vue?vue&type=style&index=0&id=67f0a9db&lang=scss"

const __exports__ = script;

export default __exports__